import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-home',
  templateUrl: './recupera.component.html',
  styleUrls: ['./recupera.component.css']
})
export class RecuperaComponent implements OnInit, OnDestroy {
  private pass1FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(6)
  ]);
  private pass2FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(6)
  ]);

  public formGroup = new FormGroup({
    pass1: this.pass1FormControl,
    pass2: this.pass2FormControl
  });

  public subscription?: Subscription;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService,
  ) {
  }

  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    this.unsubscribe();
  }
  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  public equalPassword() {
    return this.pass1FormControl.value === this.pass2FormControl.value;
  }

  public onLogin() {
    this.unsubscribe();
    const pass: string = this.pass1FormControl.value!.toString();
    const user: string = this.route.snapshot.queryParams["user"];
    const code: string = this.route.snapshot.queryParams["code"];
    this.pass1FormControl.setValue("");
    this.pass2FormControl.setValue("");
    this.pass1FormControl.markAsUntouched();
    this.pass2FormControl.markAsUntouched();
    this.subscription = this.httpClient.post(
      `/api/login/resetpassword`,
      { pass, user, code }
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.snackBarService.exibirSucesso('Senha Alterada!');
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro ${err.status} (${err.statusText})`);
      }
    });
  }
  public onVoltar() {
    const url = this.route.snapshot.queryParams["url"];
    this.router.navigate([''], { queryParams: { url } });
  }

}
